import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, Chip, List, ListItemButton, ListItemText, Paper, Stack, Typography } from '@mui/material';
import { listApplications } from '../../api/academic';
import { EmptyState } from '../../components/EmptyState';

const READY_STATUSES = new Set(['READY_TO_FLY', 'DEPARTED', 'ARRIVED']);

export const LatestAdmissionsCard = () => {
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ['dashboard', 'latest-admissions'],
    queryFn: () => listApplications({ page: 1, pageSize: 5 }),
  });

  const applications = query.data?.data ?? [];

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="subtitle1">Latest admissions</Typography>
        <Typography
          variant="caption"
          color="primary"
          sx={{ cursor: 'pointer', fontWeight: 600 }}
          onClick={() => navigate('/admissions')}
        >
          View all
        </Typography>
      </Stack>
      {applications.length === 0 ? (
        <EmptyState loading={query.isLoading} message="No applications yet" />
      ) : (
        <List dense disablePadding>
          {applications.map((app) => (
            <ListItemButton key={app.id} onClick={() => navigate('/admissions')} sx={{ borderRadius: 2, px: 1 }}>
              <ListItemText
                primary={`${app.student.firstName} ${app.student.lastName}`}
                secondary={`${app.applicationNumber} · ${app.university.name}`}
              />
              <Box>
                <Chip
                  size="small"
                  label={app.status.replace(/_/g, ' ')}
                  color={READY_STATUSES.has(app.status) ? 'success' : 'default'}
                />
              </Box>
            </ListItemButton>
          ))}
        </List>
      )}
    </Paper>
  );
};
